function cov_2bv6nf5xcw() {
  var path = "/app/src/components/default-promo-widget/components/non-ltf-snippet/index.ts";
  var hash = "8b987c7cb8444069826fc12fdb0672275b042754";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/app/src/components/default-promo-widget/components/non-ltf-snippet/index.ts",
    statementMap: {},
    fnMap: {},
    branchMap: {},
    s: {},
    f: {},
    b: {},
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "8b987c7cb8444069826fc12fdb0672275b042754"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_2bv6nf5xcw = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_2bv6nf5xcw();
export { NonLtfSnippet } from './non-ltf-snippet';